import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import QuickStartSection from './components/QuickStartSection';
import FeaturesSection from './components/FeaturesSection';
import PopularArticles from './components/PopularArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <QuickStartSection />
        <FeaturesSection />
        <PopularArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '哔咔漫画官方指南',
            url: typeof window !== 'undefined' ? window.location.origin : '',
            description:
              '哔咔漫画官方指南 - 哔咔下载与使用全攻略。为二次元爱好者提供最全面的哔咔下载、注册、使用教程。',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: '{search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </>
  );
}